import { render } from "./CreateBook.vue?vue&type=template&id=07cc6dda&scoped=true"
import script from "./CreateBook.vue?vue&type=script&lang=js"
export * from "./CreateBook.vue?vue&type=script&lang=js"

import "./CreateBook.vue?vue&type=style&index=0&id=07cc6dda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cc6dda"]])

export default __exports__